import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';
import { cloneDeep } from 'lodash';

const initialState = {
  allSites: { count: 0, rows: [] },
  selectedSitesPlaces: [],
  selectedSitesQuestions: [],
  sites: { count: 0, rows: [] },
  loading: false,
  checkDelete: {},
};

const requestSitesStart = (state, action) => {
  return updateObject(state, { loading: true });
};

const fetchSitesSuccess = (state, action) => {
  return updateObject(state, {
    sites: action.sites,
    loading: false
  });
};

const fetchAllSitesSuccess = (state, action) => {
    return updateObject(state, {
      allSites: action.sites,
      loading: false
    });
};

const requestSitesFail = (state, action) => {
  return updateObject(state, { loading: false });
};

const deleteSitesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const checkDeleteSitesSuccess = (state, action) => {
  return updateObject(state, { 
    checkDelete: action.checkDelete,
    loading: false 
  });
}

const updateSitesSuccess = (state, action) => {
  const sitesState = state.sites;
  const index = sitesState.rows.findIndex(site => site._id === action.site._id);
  sitesState.rows[index] = {...action.site};
  return updateObject(state, { sites: sitesState, loading: false });
}

const postSitesSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const selectSitePlaces = (state, action) => {
    const selectedSitesClone = [...state.selectedSitesPlaces];
    const index = selectedSitesClone.findIndex(site => site._id === action.site._id)
    if (index > -1) {
        selectedSitesClone.splice(index, 1);
    } else {
        selectedSitesClone.push(action.site)
    }

    return updateObject(state, { selectedSitesPlaces: selectedSitesClone });
}

const setSitePlaces = (state, action) => {
  return updateObject(state, { selectedSitesPlaces: action.site });
}

const deleteFilteredSite = (state, action) => {
  const { selectedSitesPlaces } = state;
  return updateObject(state, { selectedSitesPlaces: selectedSitesPlaces.filter((el) => (el._id !== action.site._id)) });
}

const selectSiteQuestions = (state, action) => {
    return updateObject(state, { selectedSitesQuestions: [action.site] });
}

const defaultSiteSelectedPlaces = (state, action) => {
    const newSelectedSitesPlaces = []
    action.user.sites.map(site => newSelectedSitesPlaces.push(site))
    return updateObject(state, { selectedSitesPlaces: newSelectedSitesPlaces });
}

const defaultSiteSelectedQuestions = (state, action) => {
    let newSelectedSitesQuestions = []

    if (action.user.sites.length > 0) {
        newSelectedSitesQuestions = [action.user.sites[0]];
    }

    return updateObject(state, { selectedSitesQuestions: newSelectedSitesQuestions });
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.REQUEST_SITES_START: return requestSitesStart(state, action);
    case actionTypes.FETCH_SITES_SUCCESS: return fetchSitesSuccess(state, action);
    case actionTypes.FETCH_ALL_SITES_SUCCESS: return fetchAllSitesSuccess(state, action);

    case actionTypes.REQUEST_SITES_FAIL: return requestSitesFail(state, action);
    case actionTypes.DELETE_SITES_SUCCESS: return deleteSitesSuccess(state, action);
    case actionTypes.CHECK_DELETE_SITES_SUCCESS: return checkDeleteSitesSuccess(state, action);
    case actionTypes.UPDATE_SITES_SUCCESS: return updateSitesSuccess(state, action);
    case actionTypes.POST_SITES_SUCCESS: return postSitesSuccess(state, action);
    case actionTypes.SELECT_SITE_PLACES: return selectSitePlaces(state, action);
    case actionTypes.FILTER_SITES_REMOVE: return deleteFilteredSite(state, action);
    case actionTypes.SET_SITE_PLACES: return setSitePlaces(state, action);
    case actionTypes.SELECT_SITE_QUESTIONS: return selectSiteQuestions(state, action);
    case actionTypes.SELECT_DEFAULT_PLACES: return defaultSiteSelectedPlaces(state, action);
    case actionTypes.SELECT_DEFAULT_QUESTIONS: return defaultSiteSelectedQuestions(state, action);


    default: return state;
  }
};

export default reducer;